/*
 * @Author: your name
 * @Date: 2021-03-30 16:03:37
 * @LastEditTime: 2021-08-12 15:54:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \alsw_web\src\router\pro.js
 */
/**
 * org模块路由
 * Created by kb on 2017/09/04.
 */
import _import from './_import_development'

export  default {
  path: '/pro',
  name: 'pro',
  component: _import("Home"),
  meta: {permission: false},
  children: [
    { path: 'prolist',component:_import("pro/prolist"),name:'商品列表页面'},
    { path: 'shopping',component:_import("pro/shopping"),name:'购物车'},
    { path: 'OrderList',component:_import("pro/OrderList"),name:'订单列表',meta:{ keepAlive:true }},
    { path: 'OrderAuditList',component:_import("pro/OrderAuditList"),name:'订单审核'},
    { path: 'OrderInfo',component:_import("pro/OrderInfo"),name:'订单详情'},
    { path: 'OrderPreList',component:_import("pro/OrderPreList"),name:'预订单列表',meta:{ keepAlive:true }},
    { path: 'OrderPreInfo',component:_import("pro/OrderPreInfo"),name:'预订单详情'},
    { path: 'OrderPreEdit',component:_import("pro/OrderPreEdit"),name:'预订单修改'},
    { path: 'OrderPreDetailList',component:_import("pro/OrderPreDetailList"),name:'预订单汇总'},
    { path: 'OrderNoProDetailList',component:_import("pro/OrderNoProDetailList"),name:'缺货单单汇总'},
    { path: 'OrderNoProInfo',component:_import("pro/OrderNoProInfo"),name:'缺货单详情'},
    { path: 'OrderNoProEdit',component:_import("pro/OrderNoProEdit"),name:'缺货单修改'},
    { path: 'OrderNoProList',component:_import("pro/OrderNoProList"),name:'缺货单列表'},
    { path: 'OrderEdit',component:_import("pro/OrderEdit"),name:'订单修改'},
    { path: 'OrderAdd',component:_import("pro/OrderAdd"),name:'订单新增'},

    { path: 'PaymentOrderList',component:_import("pro/PaymentOrderList"),name:'付款单列表'},
    { path: 'PaymentOrderAdd',component:_import("pro/PaymentOrderAdd"),name:'付款单新增'},
    { path: 'PaymentOrderInfo',component:_import("pro/PaymentOrderInfo"),name:'付款单详情'},

    { path: 'PaymentOrderAddByComp',component:_import("pro/PaymentOrderAddByComp"),name:'收款单新增'},
    { path: 'PaymentOrderInfoByComp',component:_import("pro/PaymentOrderInfoByComp"),name:'收款单新增'},

    { path: 'AccountList',component:_import("pro/AccountList"),name:'对账列表'},
    { path: 'AccountAdd',component:_import("pro/AccountAdd"),name:'对账新增'},
    { path: 'AccountInfo',component:_import("pro/AccountInfo"),name:'对账详请'},
    { path: 'AccountInfoEdit',component:_import("pro/AccountInfoEdit"),name:'对账编辑'},
    { path: 'info',component:_import("pro/info"),name:'订单列表2'},

    { path: '1',component:_import("pro/1"),name:'订单列表2'},


    { path: 'OrderDetailProPlace',component:_import("pro/OrderDetailProPlace"),name:'赠品余量下单'},
    { path: 'OrderDetailProPlaceInfo',component:_import("pro/OrderDetailProPlaceInfo"),name:'累计手动赠赠品余量详情'},
    { path: 'OrderDetailProPlaceAdd',component:_import("pro/OrderDetailProPlaceAdd"),name:'累计手动赠赠品余量编辑'},

    { path: 'OrderDetailProList',component:_import("pro/OrderDetailProList"),name:'赠品余量列表'},
    { path: 'OrderDetailProInfo',component:_import("pro/OrderDetailProInfo"),name:'赠品余量详情'},
    { path: 'OrderDetailProAdd',component:_import("pro/OrderDetailProAdd"),name:'赠品余量编辑'},
    { path: 'RemindingList',component:_import("pro/RemindingList"),name:'到货提醒列表'},


    { path: 'flOrderList',component:_import("pro/FlOrderList"),name:'返利单列表'},
    { path: 'flOrderAdd',component:_import("pro/FlOrderAdd"),name:'返利单编辑'},
    { path: 'flOrderInfo',component:_import("pro/FlOrderInfo"),name:'返利单详情'},

    { path: 'PredictFlOrderList',component:_import("pro/PredictFlOrderList"),name:'预计返利单列表',meta:{ keepAlive:true }},

    { path: 'OdSignList',component:_import("pro/OdSignList"),name:'到货签收列表',meta:{ keepAlive:true }},

    { path: 'DeliveryList',component:_import("pro/DeliveryList"),name:'待发货列表'},
    { path: 'CancelOrderList',component:_import("pro/CancelOrderList"),name:'退货单列表'},
    { path: 'CancelOrderInfo',component:_import("pro/CancelOrderInfo"),name:'退货单详情'},
    { path: 'CancelOrderAdd',component:_import("pro/CancelOrderAdd"),name:'退货单新增'},
    { path: 'CancelOrderEdit',component:_import("pro/CancelOrderEdit"),name:'退货单修改'},

    { path: 'TestProductList',component:_import("pro/TestProductList"),name:'试用装列表'},
    { path: 'TestProductInfo',component:_import("pro/TestProductInfo"),name:'试用装申请详情'},
    { path: 'TestProductAdd',component:_import("pro/TestProductAdd"),name:'试用装申请'},
    { path: 'TestProductEdit',component:_import("pro/TestProductEdit"),name:'试用装申请修改'},

    { path: 'AuthorizeList',component:_import("pro/AuthorizeList"),name:'授权申请列表'},
    { path: 'AuthorizeAdd',component:_import("pro/AuthorizeAdd"),name:'授权申请'},
    { path: 'AuthorizeInfo',component:_import("pro/AuthorizeInfo"),name:'授权申请详情'},
    { path: 'AuthorizeEdit',component:_import("pro/AuthorizeEdit"),name:'授权申请修改'},

    { path: 'AfterSaleList',component:_import("pro/AfterSaleList"),name:'售后申请列表'},
    { path: 'AfterSaleAdd',component:_import("pro/AfterSaleAdd"),name:'新增售后申请'},
    { path: 'AfterSaleInfo',component:_import("pro/AfterSaleInfo"),name:'售后申请详情'},
    { path: 'AfterSaleEdit',component:_import("pro/AfterSaleEdit"),name:'售后申请修改'},
  ]
}




// WEBPACK FOOTER //
// ./src/router/pro.js